import DataUtil from '../../utils/DataUtil';

export {
  DataUtil,
};
